import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  private intervalId: any;
  private shutdownDate = new Date('2025-11-14T23:59:59'); // November 14, 2025 at 11:59 PM

  constructor(private $translate: TranslateService) {}

  ngOnInit() {
    this.updateTimer();
    // Update every second
    this.intervalId = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateTimer() {
    const now = new Date().getTime();
    const shutdownTime = this.shutdownDate.getTime();
    const timeRemaining = shutdownTime - now;

    if (timeRemaining <= 0) {
      // Platform has shut down
      this.displayTime(0, 0, 0, 0);
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    this.displayTime(days, hours, minutes, seconds);
  }

  private displayTime(days: number, hours: number, minutes: number, seconds: number) {
    const daysElement = document.getElementById('days');
    const hoursElement = document.getElementById('hours');
    const minutesElement = document.getElementById('minutes');
    const secondsElement = document.getElementById('seconds');

    if (daysElement) {
      daysElement.textContent = days.toString().padStart(2, '0');
    }
    if (hoursElement) {
      hoursElement.textContent = hours.toString().padStart(2, '0');
    }
    if (minutesElement) {
      minutesElement.textContent = minutes.toString().padStart(2, '0');
    }
    if (secondsElement) {
      secondsElement.textContent = seconds.toString().padStart(2, '0');
    }
  }
}
